import React, { FC } from 'react';
import { LocalLibrary } from '@mui/icons-material';
import { MenuButton, useRichTextEditorContext } from 'mui-tiptap';
import { getSelectedText } from '../../tiptapHelper';
import { useGuideCmsContext } from '../../../GuideCmsContext';

export const AddStandardLinkToolbarButton: FC = () => {
  const { openStandardLinkDialog } = useGuideCmsContext();
  const editor = useRichTextEditorContext();

  const handleOnClick = async () => {
    if (!editor) return;
    await openStandardLinkDialog(getSelectedText(editor));
  };
  if (!editor) return null;
  return (
    <MenuButton disabled={!editor?.isEditable} IconComponent={LocalLibrary} tooltipLabel="Lenke til standard" onClick={handleOnClick}></MenuButton>
  );
};
